import Navigation from "@/components/layout/Navigation";
import Footer from "@/components/layout/Footer";
import HeroSection from "@/components/sections/HeroSection";
import BeliefsSection from "@/components/sections/BeliefsSection";
import ProductsSection from "@/components/sections/ProductsSection";
import HowSection from "@/components/sections/HowSection";
import PartnerSection from "@/components/sections/PartnerSection";
import ContactSection from "@/components/sections/ContactSection";

const Index = () => {
  return (
    <div className="min-h-screen overflow-x-clip bg-background text-foreground">
      <Navigation />
      <main>
        <HeroSection />
        <BeliefsSection />
        <ProductsSection />
        <HowSection />
        <PartnerSection />
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
};

export default Index;
